import { useEffect, useState } from "react";
import {
  EditableSelectComponent,
  EditableTextareaComponent,
  SectionHeader,
} from "components/index";
import { toast } from "react-toastify";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { API_URL } from "constants/index";
import { useSession } from "@clerk/clerk-react";
import {
  WaterConnectedTo,
  WaterUnitInfoDto,
} from "shared/types/water-info";
import {Water } from "assets/icons";
// Meters verhuisd naar voorzieningen (assets) — sectie verborgen.
// import WaterMeters from "./waterMeters";

const WaterUnitInfoComponent = ({
  waterSystemInfo,
  handleWaterSystemInfoChangeInParent,
  handleSaveInParent,
  handleCloseParent,
  onEditClick,
  parentEditMode = true,
}: any) => {
  const [editMode, setEditMode] = useState<boolean>(parentEditMode || true);
  const [editedWaterSystemInfo, setEditedWaterSystemInfo] =
    useState<WaterUnitInfoDto | null>(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const { session } = useSession();

  useEffect(() => {
    console.log(waterSystemInfo);
    setEditedWaterSystemInfo(waterSystemInfo);
  }, []); // don't use the dependency here because it will refresh the component on tab switch

  useEffect(() => {
    setEditMode(parentEditMode);
  }, [parentEditMode]);

  const updateWaterSystemInfo = (updatedFields: any) => {
    setHasUnsavedChanges(true);
    setEditedWaterSystemInfo((prev: any) => ({ ...prev, ...updatedFields }));

    if (handleWaterSystemInfoChangeInParent) {
      handleWaterSystemInfoChangeInParent({
        ...waterSystemInfo,
        ...updatedFields,
      });
    }
  };

  const handleSave = async () => {
    setHasUnsavedChanges(false);

    if (handleSaveInParent) {
      handleSaveInParent();
    } else {
      try {
        await fetchWithAuth(
          `${API_URL}/water-info/unit`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(editedWaterSystemInfo),
          },
          session,
        );
        toast.success("Water systeem informatie succesvol bijgewerkt!");
      } catch (e) {
        console.error(e);
        toast.error(
          "Er is een fout opgetreden bij het bijwerken van de water systeem informatie.",
        );
      }
    }
  };

  const localOnEditClick = () => {
    setEditMode((prevMode) => !prevMode);
    if (!editMode) {
      setEditedWaterSystemInfo(waterSystemInfo);
    }
  };

  const onUpdateRemarks = (remarks: string) => {
    updateWaterSystemInfo({ remarks: remarks });
  };

  const onUpdateConnectedTo = (connectedTo: any) => {
    updateWaterSystemInfo({ connectedTo: connectedTo });
  };

  return (
    <section
      key="waterSystem"
      className="flex flex-col gap-0 rounded-md bg-white"
    >
      <SectionHeader
        title="Waterhuishouding"
        icon={<Water />} // Ensure this is the correct icon component
        editMode={editMode}
        onEditClick={onEditClick || localOnEditClick}
        onSaveClick={() => handleSave()}
        onCloseClick={() => {
          if (handleCloseParent) handleCloseParent();
        }}
        showEditToggle={true}
        sticky={false}
        hasUnsavedChanges={hasUnsavedChanges}
        hideCloseAction={true}
      />

      {/* Afvoer Section */}
      <div className="p-3">
        <h2 className="font-bold text-lg">Afvoer</h2>
        <div className="gap-3 sm:grid sm:grid-cols-2">
          <div className="flex flex-col gap-3 rounded-md border border-neutral-primary/20 p-3">
            <header className="flex items-center gap-2 text-sm font-medium">
              <span
                className={`inline-block h-5 w-5 rounded-full border border-neutral-primary/30`}
              />
              <p>
                Opmerkingen op Waterhuishouding in unit
              </p>
            </header>
            <EditableTextareaComponent
              label="Geef hier nuttige informatie weer"
              value={editedWaterSystemInfo?.remarks || ""}
              isLoading={false}
              editMode={editMode}
              onChange={onUpdateRemarks}
            />
          </div>

          <div className="flex flex-col gap-3 rounded-md border border-neutral-primary/20 p-3">
            <header className="flex items-center gap-2 text-sm font-medium">
              <span
                className={`inline-block h-5 w-5 rounded-full border border-neutral-primary/30`}
              />
              <p>
                Is de watervoorziening gekoppeld aan een private meter
                of aan een collectief systeem (gemeenschappelijke meter)?
              </p>
            </header>
            <EditableSelectComponent
              label="Maak een keuze"
              value={
                editedWaterSystemInfo?.connectedTo
                  ? editedWaterSystemInfo?.connectedTo
                  : ""
              }
              options={Object.values(WaterConnectedTo).map((value) => ({
                label: value,
                value,
              }))}
              editMode={editMode}
              onChange={onUpdateConnectedTo}
            />
          </div>


          {/*
            Meters worden nu beheerd als voorzieningen (assets), niet meer hier.
            Sectie verborgen — zie Instellingen > "Meters in documenten".
            {waterSystemInfo && waterSystemInfo.id && (
              <WaterMeters
                meters={waterSystemInfo.waterMeters}
                incomingWaterUnitInfoId={waterSystemInfo && waterSystemInfo.id}
              />
            )}
          */}

          {/* Repeat for any additional file upload sections */}
        </div>
      </div>


    </section>
  );
};

export default WaterUnitInfoComponent;
